import { render } from "./specialistsAvailableSection.vue?vue&type=template&id=7f952215&scoped=true"
import script from "./specialistsAvailableSection.vue?vue&type=script&lang=js"
export * from "./specialistsAvailableSection.vue?vue&type=script&lang=js"

import "./specialistsAvailableSection.vue?vue&type=style&index=0&id=7f952215&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f952215"]])

export default __exports__